import React from 'react'
import {numberAddCommas} from '../../../../../../servos/formValidations'

const frequencyMap = {
  yearly: 'annually',
  fortnightly: 'fortnightly',
  monthly: 'monthly',
  weekly: 'weekly',
}

class AdditionalIncome extends React.Component {
  render() {
    const {
      income,
      title,
      amountLabel,
      amountPreviousYearLabel,
    } = this.props

    const {
      amount,
      amountPreviousYear,
      frequency,
      frequencyPreviousYear,
      address,
      periodMonths,
      periodYears,
      additionalPaygIncomes,
    } = income

    const {
      bonus,
      overtime,
      commission,
      allowance
    } = additionalPaygIncomes

    return(
      <div>
        <div className='big'>{ title }</div>

        { amount !== null &&
          <div className="income-attribute">
            <span className='grey'>{ amountLabel ? amountLabel : 'Amount' }: </span>
            <span>{ `${'$'+numberAddCommas(amount)} ${frequencyMap[frequency]}` }</span>
          </div>
        }

        {amountPreviousYearLabel &&
        <div className="income-attribute">
          <span className='grey'>{ amountPreviousYearLabel ? amountPreviousYearLabel : 'Amount' }: </span>
          <span>{ `${'$'+numberAddCommas(amountPreviousYear)} ${frequencyMap[frequencyPreviousYear]}` }</span>
        </div>
        }

        { address &&
        <div className="income-attribute">
          <span className='grey'>Address: </span>
          <span>{ address }</span>
        </div>
        }

        {
          (periodMonths || periodYears) &&
          <div className="income-attribute">
            <span className='grey'>Period: </span>
            <span>
              { periodYears &&
              `${periodYears} year${ periodYears > 1 ? 's' : ''}`
              }
              { (periodMonths && periodYears) &&
                <span> and </span>
              }

              { periodMonths &&
                `${periodMonths} month${ periodMonths > 1 ? 's' : ''}`
              }
            </span>
          </div>
        }


        { (bonus || overtime || commission || allowance) &&
          <div className='mt-2 ml-2 pl-3 border-left border-grey'>
            { bonus &&
            <div>
              <div className="income-attribute">
                <span className='grey'>Bonus in FY 2018-2019: </span>
                <span>{'$' + numberAddCommas(bonus.amount)} {frequencyMap[bonus.frequency]}</span>
              </div>

              <div className="income-attribute">
                <span className='grey'>Bonus in FY 2017-2018: </span>
                <span>{'$' + numberAddCommas(bonus.amountPreviousYear)} {frequencyMap[bonus.frequencyPreviousYear]}</span>
              </div>
            </div>
          }

          { overtime &&
            <div className="income-attribute">
              <span className='grey'>Overtime: </span>
              <span>
                { '$' + numberAddCommas(overtime.amount) } { frequencyMap[overtime.frequency] }
                {
                  (overtime.periodMonths || overtime.periodYears) &&
                  <span>
                    <span> for </span>
                    { overtime.periodYears &&
                      `${overtime.periodYears} year${ overtime.periodYears > 1 ? 's' : ''}`
                    }

                    { (overtime.periodMonths && overtime.periodYears) &&
                      <span> and </span>
                    }
                    { overtime.periodMonths &&
                      `${overtime.periodMonths} month${ overtime.periodMonths > 1 ? 's' : ''}`
                    }
                  </span>
                }
              </span>
            </div>
          }

          { commission &&
            <div>
              <div className="income-attribute">
                <span className='grey'>Commission in FY 2018-2019: </span>
                <span>{'$' + numberAddCommas(commission.amount)} {frequencyMap[commission.frequency]}</span>
              </div>

              <div className="income-attribute">
                <span className='grey'>Commission in FY 2017-2018: </span>
                <span>{'$' + numberAddCommas(commission.amountPreviousYear)} {frequencyMap[commission.frequencyPreviousYear]}</span>
              </div>
            </div>
          }

          { allowance &&
            <div className="income-attribute">
              <span className='grey'>Untaxed allowance: </span>
              <span>{'$' + numberAddCommas(allowance.amount)} {frequencyMap[allowance.frequency]}</span>
            </div>
          }

          </div>
        }
        <hr />
      </div>
    )
  }
}

export default AdditionalIncome;
